<div class="tab-bar">
  <div class="tab">
    Tab 1
  </div>
  <div class="tab">
    Tab 2 Tab 2 Tab 2Tab 2
  </div>
  <div class="tab">
    Tab 3
  </div>
</div>

